<template>
  <div class="battle-layout">
    <!-- CSS Grid (ne Vuetify v-row/v-col) - grid-template-areas dovoluje zcela jine rozlozeni
         bunek pro mobil/desktop/chooseMode beze zmeny poradi v DOM. -->
    <div
        class="battle-layout__row"
        :class="{'battle-layout__row--choose': chooseMode, 'battle-layout__row--dungeon': dungeonMode}"
    >
      <!-- "VS" mecíky - dekorativni znacka souboje, centrovana na radek hrac+soupeř,
           pointer-events:none. Jen behem aktivniho souboje - v choose-stavu neviditelne. -->
      <v-img
          v-if="!chooseMode"
          :src="require('@/assets/pic/web/vs_swords.png')"
          contain
          class="battle-layout__vs-icon"
      />
      <!-- chooseMode (M3 mobilni redesign): souper (pokemon/obstacle) cela sirka nahoru, hrac
           ("Choose pokemon" ctverecek) cela sirka pod nim - stred (BattleCenter) se v chooseMode
           vubec nerenderuje. Umisteni resi grid-template-areas nize. -->
      <div class="battle-layout__player">
        <slot name="player" />
      </div>
      <div class="battle-layout__opponent">
        <slot name="opponent" />
      </div>
      <div v-if="!chooseMode" class="battle-layout__center pb-0 pt-0">
        <slot name="center" />
      </div>
    </div>

    <!-- Akcni lista je normalni (ne fixed/sticky) flex polozka na konci sloupce - vejde se vzdy
         diky flex:1/min-height:0 na radku nad ni (viz .battle-layout nize). SkillActionBar
         (pokud naplneny) primo nad ni. -->
    <div class="battle-layout__bottom-bar">
      <div v-if="$slots['skill-actions']" class="battle-layout__skill-actions">
        <slot name="skill-actions" />
      </div>
      <div v-if="$slots['actions']" class="battle-layout__actions">
        <slot name="actions" />
      </div>
    </div>

    <!-- below/trainers jen kdyz je slot skutecne naplneny - prazdny wrapper by jinak zabiral
         misto navic. below dnes nikdo nepouziva, trainers docasne vypnuto (viz BattleScreen.vue). -->
    <div v-if="$slots['below']" class="battle-layout__below">
      <slot name="below" />
    </div>

    <div v-if="$slots['trainers']" class="battle-layout__trainers mt-2">
      <slot name="trainers" />
    </div>
  </div>
</template>

<script>
// Grid kostra sdílená všemi bojovými módy (fight/trenér/team rocket/liga/dungeon/překážka).
// Definuje layout JEDNOU - jednotlivé módy jen naplní sloty. Design viz
// claude/components/battle-skills.md.
export default {
  name: "BattleLayout",
  props: {
    // "choose/encounter" stav - viz komentar u v-row vyse
    chooseMode: {type: Boolean, default: false},
    // dungeon-progress-badge (BattleScreen.vue) je nad timhle gridem fixed pripleply na mobilni
    // horni listu - musime kartam pridat mesto, aby se s nim netloukly.
    dungeonMode: {type: Boolean, default: false},
  },
}
</script>

<style scoped>
.battle-layout__row {
  /* kotva pro vystredenou "VS" znacku (viz .battle-layout__vs-icon) */
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "player opponent"
    "center center";
  gap: 12px;
  padding: 16px 8px 0 8px;
  /* Vyplni zbyvajici vysku po odectení spodni listy (flex na .battle-layout nize) - definitivni
     (ne auto) vyska radku, aby grid-template-rows:1fr 1fr nize melo vuci cemu pocitat 50 %. */
  flex: 1 1 auto;
  min-height: 0;
}
.battle-layout__row--choose {
  grid-template-columns: 1fr;
  grid-template-areas:
    "opponent"
    "player";
}
@media (min-width: 960px) {
  .battle-layout__row {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: "player center opponent";
  }
  .battle-layout__row--choose {
    grid-template-columns: 1fr;
    grid-template-areas:
      "opponent"
      "player";
  }
}
@media (max-width: 959px) {
  .battle-layout__row {
    /* 50/50 rozdeleni obsahu radku - plati jak pro aktivni souboj (karty/report), tak pro
       chooseMode (soupeř/choose ctverecek), oba maji presne 2 radky. */
    grid-template-rows: 1fr 1fr;
  }
  .battle-layout__player,
  .battle-layout__opponent,
  .battle-layout__center {
    /* Bez tohoto by obsah (hlavne FightReport s castmi s pevnou min-vyskou) mohl vynutit radek
       vyssi nez 1fr - stejny "min-height:auto na flex/grid polozce" jev. */
    min-height: 0;
  }
  .battle-layout__row--dungeon {
    /* Musi presne odpovidat vysce .dungeon-progress-badge (BattleScreen.vue, top:60px, 36px
       vysoky), aby karty na nej navazovaly bez mezery. */
    padding-top: 36px;
  }
  /* Mobil ma dynamickou vysku karet (na rozdil od desktopu s pevnymi 400px) - top je proto
     procento vuci cele (dynamicke) vysce .battle-layout__row (position:relative kotva vyse),
     odvozene ze stejneho "zlaty rez 2/3 zespoda" pravidla jako desktopova pixelova hodnota
     (top:283px nize): 2/3 bod prvniho radku = padding-top + (H - padding-top - gap)/2 * 2/3,
     coz po rozepsani vyjde na calc(33.333% + X px), kde X = (2*padding-top - gap)/3
     (nezavisle na H, funguje pro libovolnou dynamickou vysku). */
  .battle-layout__row:not(.battle-layout__row--dungeon) .battle-layout__vs-icon {
    top: calc(33.333% + 6.67px);
  }
  .battle-layout__row--dungeon .battle-layout__vs-icon {
    top: calc(33.333% + 20px);
  }
}
.battle-layout__player {
  grid-area: player;
}
.battle-layout__opponent {
  grid-area: opponent;
}
.battle-layout__vs-icon {
  position: absolute;
  left: 50%;
  /* Desktopova hodnota - karty tam maji vzdy pevnych 400px (PokemonDetail.vue desktop
     override), takze pozice = padding-top radku + 267px (zlaty rez zespoda, 400 * 2/3 = 267).
     Mobilni procentualni varianta viz media query vyse. */
  top: 283px;
  transform: translate(-50%, -50%);
  /* v-img bez vyslovne vysky/aspect-ratio se u nas defaultne nerenderuje (0px box) - clamp()
     misto pevnych 70px zmensuje mecik na uzkem mobilu (~340-380px), postupne roste s viewportem. */
  width: clamp(42px, 9vw, 70px);
  height: clamp(42px, 9vw, 70px);
  /* Vysoky z-index preskakuje interni z-index prvky souperovy karty (jmeno/HP kontejner,
     level-badge), ktere v choose-stavu prekryvaji spodek karty. */
  z-index: 50;
  pointer-events: none;
  filter: drop-shadow(2px 4px 3px rgba(0,0,0,0.8)) drop-shadow(0px 0px 10px rgba(0,0,0,0.6));
}
.battle-layout__center {
  grid-area: center;
  /* Stare Fight2/Dungeon obalovaly FightReport do v-card-text s Vuetify defaultnim
     line-height 1.375rem - bez neho se text v kolecku poctu kol (FightReport.vue) posouva
     dolu. FightReport se neprepisuje, dorovnava se to tady. */
  line-height: 1.375rem;
}

@media (max-width: 959px) {
  .battle-layout {
    /* flex sloupec vyplnujici celou vysku rodice (jen mobil), aby .battle-layout__row (flex:1
       vyse) mel vuci cemu pocitat "zbyvajici" vysku pro 50/50 rozdeleni. overflow:hidden je
       tvrda pojistka - i kdyby se nekde presto vynutila vetsi vyska, .battle-layout jako celek
       nemuze vyrust nad svych 100 %, akcni lista (flex:none, posledni polozka) tak zustane
       vzdy viditelna. */
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
  .battle-layout__row {
    /* stejna pojistka o uroven niz. */
    overflow: hidden;
  }
  .battle-layout__below,
  .battle-layout__trainers {
    flex: none;
  }
  .battle-layout__bottom-bar {
    flex: none;
    background-color: rgba(0, 0, 0, 0.55);
  }
}
</style>
